import { render, staticRenderFns } from "./InactiveUniRequists.vue?vue&type=template&id=4205a8fa&"
import script from "./InactiveUniRequists.vue?vue&type=script&lang=js&"
export * from "./InactiveUniRequists.vue?vue&type=script&lang=js&"
import style0 from "./InactiveUniRequists.vue?vue&type=style&index=0&id=4205a8fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports